export default "__VITE_ASSET__DQSgt5yh__"